import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setTiposPublicacion } from '../actions/tiposPublicacionActions';
import Auth from '../auth';
import ClickOutsideHandler from './General/ClickOutsideHandler';

// Wrapper para usar hooks en class component
function MenuWrapper(props) {
  const navigate = useNavigate();
  return <Menu {...props} navigate={navigate} />;
}

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideLogout: true,
            nombreTienda: "",
            urlLogo: ""
        };
    }

    componentDidMount() {
        this.getSellerData();
    }

    async getSellerData() {
        try {
            const seller = await this.props.getSellerById(this.props.idSeller);
            
            let nombreTienda = "";
            if (seller.nombreTienda) {
                if (seller.nombreTienda.length < 20) {
                    nombreTienda = seller.nombreTienda;
                } else {
                    nombreTienda = seller.nombreTienda.substring(0, 20) + "...";
                }
            } else {
                nombreTienda = seller.razonSocial;
            }

            this.setState({ 
                nombreTienda: nombreTienda, 
                urlLogo: seller.logo 
            });

        } catch (e) {
            //toast.error("No se pudieron obtener los datos del seller.");
            return;
        }
    }

    handleClickOutside = () => {
        this.setState({ hideLogout: true });
    };

    onLogout() {
        this.setState({ hideLogout: true });
        Auth.logout();
        this.props.navigate("/login")
    }

    goToEditProfile = () => {
        this.setState({ hideLogout: true });
        this.props.setTiposPublicacion([{}]);
        this.props.navigate(`/Sellers/Editar/${this.props.idSeller}`);
    }

    render() {
        const { hideLogout, urlLogo } = this.state;
        const isSeller = this.props.tipoUsuario === 3 || this.props.tipoUsuario === 4;

        return (
            <div className="container allow-pointer-cursor prevent-select">
                <div className="row" onClick={() => this.setState({hideLogout: !hideLogout})}>
    
                    <div className="col-auto" hidden={!isSeller}>
                        <img className="avatar-logo rounded-circle" src={urlLogo} alt="logo_img"/>
                    </div>
    
                    <div className="nav-link dropdown-toggle waves-effect waves-dark profile-pic col-auto">
                        <h6 className="d-inline color-blanco-megatone hidden-md-down px-1 mt-1">
                        {
                            isSeller ?  this.state.nombreTienda : this.props.userName
                        }
                        </h6>
                        <i className="fa fa-angle-down color-blanco-megatone px-1"/>
                    </div>

                    {!hideLogout && (
                        <ClickOutsideHandler onClickOutside={this.handleClickOutside}>
                            <div className="position-relative">
                                <div className="dropdown-menu-custom col-auto position-absolute end-0 bg-white border rounded shadow mt-2 p-0">

                                    <div
                                        className="dropdown-item p-2 hover-background-color d-flex align-items-center"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.goToEditProfile();
                                        }}
                                    >
                                        <i className="color-gris-megatone fa fa-user me-2" /> Mi Perfil
                                    </div>
                                    
                                    <div
                                        className="dropdown-item p-2 hover-background-color d-flex align-items-center"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.onLogout();
                                        }}
                                    >
                                        <i className="color-gris-megatone fa fa-power-off me-2" /> Salir
                                    </div>
                                </div>
                            </div>
                        </ClickOutsideHandler>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    tipoUsuario: state.general.tipoUsuario,
    idSeller: state.general.idSeller,
    userName: state.general.userName
})

export default connect(mapStateToProps, { setTiposPublicacion })(MenuWrapper);